import { Pyme } from "../api";
import { 
  setOptionsList, 
  setPymeList,
  showLoading,
  showInnerLoading,
  setQuotation,
  setClientValue
} from "../actions";
import { mapSelectList } from "../helpers";

export function getOccupations() {
  return function func(dispatch, getState) {
    const { options } = getState();
    return Pyme.getOccupations(options.productCode).then(response => {
      if (response) {
        dispatch(setOptionsList('occupations', response));
        if (response.length === 1)
          dispatch(setClientValue('occupation', mapSelectList(response)[0]));
      }
    });
  };
}

export function getCoveragePlans() {
  return function func(dispatch) {
    dispatch(showInnerLoading(true));
    return Pyme.getCoveragePlans().then(response => {
      if (response) {
        dispatch(setPymeList('coveragePlans', response));
      }
      dispatch(showInnerLoading(false));
    });
  };
}

export function getCoverageModules() {
  return function func(dispatch, getState) {
    const { options } = getState();
    dispatch(showInnerLoading(true));
    return Pyme.getCoverageModules(options.productCode).then(response => {
      if (response) {
        dispatch(setPymeList('coverageModules', response));
      }
      dispatch(showInnerLoading(false));
    });
  };
}

export function getQuotation() {
  return function func(dispatch, getState) {

    const { name, occupation, addressState, addressCity } = getState().client;
    const { productCode, quoter } = getState().options;
    const { coveragePlan, coverageModule } = getState().pyme;

    const request = {
      referencia: name,
      ocupacion: occupation.value,
      departamento: addressState.value,
      ciudad: addressCity ? addressCity.value : null,
      producto: productCode.toString(),
      plan: coveragePlan,
      modulo: coverageModule
    };
    
    dispatch(showLoading(true));

    return Pyme.getQuotation(request).then(response => {
      if (response) {
        dispatch(setQuotation(quoter, response, {coverageModule}));
      } else {
        dispatch(setQuotation(quoter, { respuesta: { mensaje: 'Error al obtener la cotización' }}));
      }
      dispatch(showLoading(false));
    });
  };
}